import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Text, View } from 'oio-react'
import { Link } from 'react-router-dom'
import AccountLogo from 'src/components/Account/Logo'
import ScrollView from 'src/components/utils/ScrollView'
import { useMe, useOrganization } from 'src/graphql/hooks'
import ThemeContext, { Theme } from 'src/libraries/contexts/Theme'

const AccountContainer = ({
   children,
   contentMaxWidth,
   logoutActionMessage,
   overrideLoginCheck
}) => {
   const theme = useContext(ThemeContext)
   const { organization } = useOrganization()
   const { isLoggedIn, loading: userIsLoading } = useMe()
   const coverMediaUrl = organization?.coverMedia?.file.thumbnailUrlW1600

   // Display the children if specifically asked to, or if the current user is logged in
   // eslint-disable-next-line no-mixed-operators
   const shouldDisplayChildren = overrideLoginCheck || (!userIsLoading && !isLoggedIn)

   return (
      <ScrollView
         backgroundColor="#fff"
         position="fixed"
         top="0px"
         left="0px"
         right="0px"
         bottom="0px"
         scroll="on[a-c]">
         <Theme globalNavIsHidden />
         <View
            position="absolute"
            top="0px"
            left={theme.viewportMarginLeft}
            right={theme.viewportMarginRight}
            bottom={theme.viewportMarginBottom}>
            <View
               position="relative"
               float="left"
               display="none[a-c] block[d-f]"
               width="100%[a-c] 45%[d-e] 40%[f]"
               height="100%[d-f]"
               paddingTop="56.25%[a-b] 50%[c]">
               <View
                  backgroundColor="#aaa"
                  position="absolute"
                  top="0px"
                  left="0px"
                  right="0px"
                  bottom="0px"
                  backgroundSize="cover"
                  backgroundImage={coverMediaUrl && `url(${coverMediaUrl})`}
                  backgroundPosition="center center"
               />
            </View>
            <View
               backgroundColor="#fff"
               position="relative"
               float="left"
               height="100%[c-f]"
               width="100%[a-c] 55%[d-e] 60%[f]"
               display="flex"
               justifyContent="center[a-c]"
               alignItems="center"
               paddingTop="100px"
               paddingLeft={theme.viewportPaddingLeft}
               paddingRight={theme.viewportPaddingRight}
               paddingBottom={theme.viewportPaddingBottom}
               scroll="on[d-f]">
               <View maxWidth={contentMaxWidth} maxHeight="100%" paddingBottom="60px">
                  <AccountLogo />
                  {shouldDisplayChildren && children}
                  {!overrideLoginCheck && !userIsLoading && isLoggedIn && (
                     <Text>
                        {`Whoops, looks like you are already signed in! To ${logoutActionMessage}, please `}
                        <Link to="/account/logout">logout</Link>
                        {' first.'}
                     </Text>
                  )}
               </View>
            </View>
         </View>
      </ScrollView>
   )
}

AccountContainer.propTypes = {
   overrideLoginCheck: PropTypes.bool,
   children: PropTypes.node.isRequired,
   contentMaxWidth: PropTypes.string,
   logoutActionMessage: PropTypes.string
}

AccountContainer.defaultProps = {
   overrideLoginCheck: false,
   contentMaxWidth: '450px',
   logoutActionMessage: 'access this page'
}

export default AccountContainer
